"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                CheckBox_ToggleFalseText: "No",
                CheckBox_ToggleTrueText: "Yes",
                Checkbox_ToggleValue: "Toggle value",
            }
        });
        /**
         * Framework class for CheckBox controls
         */
        var CheckBox = /** @class */ (function (_super) {
            __extends(CheckBox, _super);
            function CheckBox() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(CheckBox.prototype, "YesNoText", {
                /**
                 * The yes/no string representation of the value
                 */
                get: function () {
                    var val = $dyn.value(this.formattedValue);
                    var labelText = (val && $dyn.util.stringToBoolean(val)) ? "CheckBox_ToggleTrueText" : "CheckBox_ToggleFalseText";
                    return $dyn.label(labelText);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CheckBox.prototype, "IsStandard", {
                /**
                 * Whether or not the checkbox is using the standard style
                 */
                get: function () {
                    return $dyn.value(this.Style) === $dyn.ui.CheckBoxStyle.checkbox;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CheckBox.prototype, "CheckedSymbol", {
                /**
                 * The symbol for the current value
                 */
                get: function () {
                    var val = $dyn.value(this.formattedValue);
                    var allowEdit = $dyn.value(this.AllowEdit);
                    // Readonly checkbox in grid has different symbols than all other checkboxes
                    if (!allowEdit && this.isInGrid()) {
                        if (val && $dyn.util.stringToBoolean(val)) {
                            return "\uE001"; // check without box
                        }
                        else {
                            return "";
                        }
                    }
                    else { // normal symbols
                        if (val && $dyn.util.stringToBoolean(val)) {
                            return "\uE0A2"; // check with box
                        }
                        else {
                            return "\uE003"; // empty box
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            CheckBox.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.formattedValue($dyn.value(this.Value));
                $dyn.observe(this.Value, function (newValue) {
                    if (newValue !== $dyn.value(_this.formattedValue)) {
                        _this.formattedValue(newValue);
                    }
                });
                $dyn.observe(this.Style, function (newValue) {
                    if ((newValue === $dyn.ui.CheckBoxStyle.auto && _this.isInGrid()) || newValue === $dyn.ui.CheckBoxStyle.checkbox) {
                        $(_this.element).attr("data-dyn-focus", ".checkBox");
                        _this.labelForId("_check");
                    }
                    else {
                        $(_this.element).attr("data-dyn-focus", ".toggle-box");
                        _this.labelForId("_toggle");
                    }
                });
            };
            /**
             * Toggles the current value if able
             */
            CheckBox.prototype.toggleValue = function (evt) {
                if (this.allowUserChanges()) {
                    var val = $dyn.value(this.formattedValue);
                    this.formattedValue(this.computeToggleValue(val));
                    this.setValue($dyn.value(this.formattedValue));
                }
            };
            /**
             * The keydown event handler
             * @param event The keydown event
             */
            CheckBox.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            /**
             * The click event handler
             * @param event The click event
             */
            CheckBox.prototype.clickHandler = function (event) {
                if (event && event.which === $dyn.ui.MouseButtonCodes.rightButton) {
                    return;
                }
                this.toggleValue(event);
            };
            /**
             * Update the backing value
             * @param newValue What to set the value property to
             * @param forceChange Whether to update the value property even if it hasn't changed
             * @param forceCommandCall Whether or not to call SetValue even if the control is currently not editable
             * @returns A promise that gets resolved when the value setting process is completed
             */
            CheckBox.prototype.setValue = function (newValue, forceChange, forceCommandCall) {
                var _this = this;
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var result = $.Deferred();
                if (forceCommandCall || this.allowUserChanges()) {
                    if (this.SetValue) {
                        var successCallback = function () {
                            _this.updatingBlock(function () {
                                _this.formattedValue($dyn.util.stringToBoolean($dyn.value(_this.Value)));
                            });
                            result.resolve();
                        };
                        var failureCallback = function () {
                            result.resolve(true);
                        };
                        $dyn.callFunction(this.SetValue, this, [newValue], successCallback, null /*complete*/, null /*before*/, null /*throttle*/, failureCallback);
                    }
                    else {
                        result.resolve();
                        $dyn.setValue(this, "Value", newValue, forceChange);
                    }
                }
                else {
                    result.resolve(true);
                }
                return result;
            };
            /**
             * The formattedValue getter
             * @returns The formatted value ('False' or 'True')
             */
            CheckBox.prototype.getFormattedValue = function () {
                return ($dyn.value(this.formattedValue) === "0" ||
                    $dyn.value(this.formattedValue) === false ||
                    $dyn.value(this.formattedValue) === "false") ? "False" : "True";
            };
            /** @obsolete */
            CheckBox.prototype.GetInitialState = function () {
                return { formattedValue: false };
            };
            /**
             * Gets the client state
             * @returns clientState object
             */
            CheckBox.prototype.GetState = function () {
                return {
                    formattedValue: $dyn.util.stringToBoolean($dyn.value(this.formattedValue))
                };
            };
            /**
             * Update the Control with ClientState
             * @param clientState clientState object
             * @param skipSetValue skips set value call when this is true
             * @returns Returns if it can successfully set value of control
             */
            CheckBox.prototype.ApplyState = function (clientState, skipSetValue) {
                if (skipSetValue === void 0) { skipSetValue = false; }
                if (clientState.formattedValue !== undefined) {
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    if (clientState.formattedValue !== $dyn.util.stringToBoolean($dyn.value(this.formattedValue))) {
                        this.formattedValue(clientState.formattedValue);
                        if (!skipSetValue) {
                            return this.setValue(clientState.formattedValue, true, true);
                        }
                    }
                }
            };
            CheckBox.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var defaultTarget = $(this.element);
                options.target = defaultTarget;
                var $checkBox = $(this.element).find(".checkBox");
                if ($checkBox[0] && $checkBox[0].offsetWidth) {
                    options.target = $checkBox;
                }
                else {
                    var $toggleBox = $(this.element).find(".toggle-box");
                    if ($toggleBox[0]) {
                        options.target = $toggleBox;
                    }
                }
                return options;
            };
            /**
             * Takes a formatted value and returns its toggled value as a boolean
             * @param rawValue The formatted value
             * @returns True if the raw value was falsy, otherise false
             */
            CheckBox.prototype.computeToggleValue = function (rawValue) {
                var value = $dyn.value(rawValue);
                return value === "0" || value === 0 || value === false || value === "false" ? true : false;
            };
            return CheckBox;
        }($dyn.ui.Control));
        controls.CheckBox = CheckBox;
        CheckBox.prototype.SetValue = null;
        CheckBox.prototype.IsSorted = false;
        CheckBox.prototype.bindUpdate = true;
        CheckBox.prototype.SupportsDefaultAction = false;
        CheckBox.prototype.HelpText = "";
        CheckBox.prototype.ShowLabel = true;
        CheckBox.prototype.IsFilterable = false;
        CheckBox.prototype.IsFiltered = false;
        CheckBox.prototype.recordability = $dyn.util.recordabilityDefault;
        $dyn.ui.addObservablePropertiesToPrototype(CheckBox.prototype, {
            formattedValue: false,
            labelForId: "_toggle",
            Style: $dyn.ui.CheckBoxStyle.auto,
            Value: false,
        });
        $dyn.ui.addPropertiesToPrototype(CheckBox.prototype, {
            DataSourceName: { defaultValue: "", observable: true },
            FieldName: { defaultValue: "", observable: true },
            Label: { defaultValue: "", observable: true },
        });
        // tslint:disable:object-literal-sort-keys
        var checkBoxShortcuts = {
            ToggleValue: {
                Keys: { keyCode: $dyn.ui.KeyCodes.spacebar },
                Handler: function (evt) {
                    this.toggleValue(evt);
                },
                ShowToUser: function () { return this.allowUserChanges(); },
                RecordTelemetry: false,
                Description: $dyn.label("Checkbox_ToggleValue")
            },
        };
        CheckBox.prototype.Shortcuts = $dyn.extendPrototype(CheckBox.prototype.Shortcuts, checkBoxShortcuts);
        /**
         * Framework class for CheckBox Cell controls (within inactive row)
         */
        var CheckBoxCell = /** @class */ (function (_super) {
            __extends(CheckBoxCell, _super);
            function CheckBoxCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = true;
                return _this;
            }
            Object.defineProperty(CheckBoxCell.prototype, "checked", {
                /**
                 * The value of the control element's aria-checked attribute
                 */
                get: function () {
                    var checkBoxElement = this.element.getElementsByClassName("checkBox")[0];
                    return checkBoxElement ? $dyn.util.stringToBoolean(checkBoxElement.getAttribute("aria-checked")) : false;
                },
                set: function (value) {
                    var checkBoxElement = this.element.getElementsByClassName("checkBox")[0];
                    if (checkBoxElement) {
                        checkBoxElement.setAttribute("aria-checked", value.toString());
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(CheckBoxCell.prototype, "validating", {
                /**
                 * The value of the control element's data-dyn-validating attribute
                 */
                get: function () {
                    return $dyn.util.stringToBoolean(this.element.getAttribute("data-dyn-validating"));
                },
                set: function (value) {
                    this.element.setAttribute("data-dyn-validating", value.toString());
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Toggle the value for the checkbox cell
             */
            CheckBoxCell.prototype.toggleValueForCell = function () {
                this.checked = !this.checked;
                this.validating = true;
                this.RaiseEvent($dyn.ui.ChangeEvent, {
                    bubbles: true,
                });
            };
            CheckBoxCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                if (clientState.formattedValue !== undefined) {
                    var currentValue = this.checked;
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    if (clientState.formattedValue !== currentValue) {
                        this.checked = clientState.formattedValue;
                    }
                }
                retVal.resolve();
                return retVal;
            };
            CheckBoxCell.prototype.GetState = function () {
                return {
                    formattedValue: this.checked,
                };
            };
            return CheckBoxCell;
        }(CheckBox));
        controls.CheckBoxCell = CheckBoxCell;
        CheckBoxCell.prototype.Shortcuts = {
            ToggleValue: {
                Keys: { keyCode: $dyn.ui.KeyCodes.spacebar },
                Handler: function () {
                    this.toggleValueForCell();
                },
                Description: $dyn.label("Checkbox_ToggleValue")
            }
        };
        $dyn.cellAdapter({ id: "CheckBox" });
        $dyn.cellAdapter({ id: "CheckBox", controlType: "CheckBoxCell", template: "CheckBoxCell", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CheckBox.js.map
